import React, { useState, useEffect } from 'react';
import { Grid, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useStyles } from '../../assets/jss/components/ErrorHandler/errorHandlerStyles';

export default function ErrorHandler(props) {
  const classes = useStyles(props);
  const { duration, localNotificationsState, deleteNotification, totalNotifications } = props;
  const [openSnackBar, setOpenSnackbar] = useState(null);
  const [localNotifications, setLocalNotifications] = useState(localNotificationsState);

  useEffect(() => {
    if (totalNotifications > 0) {
      if (!openSnackBar) setOpenSnackbar(true);
      setLocalNotifications(localNotificationsState);
    } else {
      setOpenSnackbar(false);
    }
  }, [openSnackBar, totalNotifications, localNotificationsState]);

  const Alert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    deleteNotification();
    setOpenSnackbar(false);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={openSnackBar}
      autoHideDuration={duration}
      onClose={handleCloseSnackbar}
    >
      <div>
        {localNotifications &&
          localNotifications.map((notification, index) => {
            return (
              <Grid key={index} item xs={12}>
                <Alert className={classes.alert} severity={notification.severity}>
                  {notification && notification.message ? notification.message : ''}
                </Alert>
              </Grid>
            );
          })}
      </div>
    </Snackbar>
  );
}
